import { cx } from 'utils/cx'

import styles from './GhostButton.module.scss'
import text from 'fukku/styles/texts.module.scss'

interface GhostButtonProps {
	buttonAttributes?: React.ComponentProps<'button'>
	'data-testid'?: string
	disabled?: boolean
	icon: React.ReactNode
	label: string
	onClick?: () => void
}

/** A button without background and border, used for secondary or less important actions,
 *  aiming to maintain a clean and minimalist look in the interface. */
export function GhostButton({
	buttonAttributes,
	'data-testid': dataTestId,
	disabled = false,
	icon,
	label,
	onClick = () => {
		/** Do nothing */
	},
}: GhostButtonProps): React.ReactNode {
	const handleOnClick = () => {
		if (!disabled) {
			onClick()
		}
	}

	return (
		<button
			{...buttonAttributes}
			type='button'
			className={cx(styles.ghost, disabled && styles.disabled)}
			onClick={handleOnClick}
			aria-disabled={disabled}
			data-testid={dataTestId}
		>
			{icon}
			<span className={text.bodyMRegular}>{label}</span>
		</button>
	)
}
